<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="part01"><a id="page_19"></a><strong>I.<br/>SISTERS UNDER THE SKIN?</strong></h2>
<p class="noindent"><a id="page_20"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// partI.vue?c7b938de